import Vue from 'vue'
import { ORG_INFO } from '@/store/mutation-types'
const system = {
    state: {
        orgInfo: {},
        breadcrumbList: []
    },
    mutations: {
        setOrgInfo(state, data) {
            state.orgInfo = data
            Vue.ls.set(ORG_INFO, data)
            document.title = data.oname
        },
        setBreadcrumbList(state, data) {
          // console.log('data', data)
          // const breadcrumbList = state.breadcrumbList
          // if (Array.isArray(data)) {
          //   state.breadcrumbList = data
          // } else {
          //   const { to: { matched, ...res }, from } = data
          //   const arr = state.breadcrumbList.filter(item => item.name !== from.name)
          //   arr.push(res)
          //   state.breadcrumbList = arr
          // }
          state.breadcrumbList = data
          // console.log('state.breadcrumbList', state.breadcrumbList)
        }
    },
    actions: {},
    getters: {
        getInfo: (state) => {
          return function (keys) {
            const data = {}
            if (typeof keys === 'string') {
              data[keys] = state.orgInfo[keys]
            }
            if (Array.isArray(keys)) {
                keys.forEach(key => {
                data[key] = state.orgInfo[key]
              })
            }
            return data
          }
        }
      }
}

export default system
